import { useDispatch, useSelector } from "react-redux";

import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import loadConfig, {
  getApiClient,
  initializeApiClient,
} from "../../Services/apiService";
import TableAHSF from "../../Components/TableAHSF";
import PopupAHSF from "../../Components/PopupAHSF";
import { setRefreshTable } from "../../Redux/Reducers/VariousVariables";
import { DeleteTechnicalReportNotes } from "../../Redux/Reducers/ReportStage/TechnicalReportNotes";
import AddEditTechnicalReportNotes from "./AddEditTechnicalReportNotes";

const TechnicalReportNotes = (props) => {
  const dispatch = useDispatch();
  const [jsonData, setJsonData] = useState({});
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const [popUpBodyOPjectDataStatus, setPopUpBodyOPjectDataStatus] =
    useState(false);
  const [popUpBodyOPjectDataAddStatus, setpopUpBodyOPjectDataAddStatus] =
    useState(false);
  const [TechnicalReportNotesId, setTechnicalReportNotesId] = useState(null);
  const state = useSelector((state) => {
    return {
      //   ApplicationInformation:
      //     state.ApplicationInformation.ApplicationInformation,
      jsonData: state.FetchDataJson.JsonData,
      //   TeamMembersPreviousExperiencePartnerships:
      //     state.TeamMembersPreviousExperiencePartnerships
      //       ?.TeamMembersPreviousExperiencePartnerships,
      //   ActiveRound: state.ApplicationInformation.ActiveRound,
    };
  });

  //   const shouldDisableFields = !(

  //     (
  //       state.ActiveRound == state.ApplicationInformation?.aI_RoundYearId &&
  //       state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
  //       window.location.href.includes("manager") == false
  //     )
  //   );
  const shouldDisableFields = window.location.href.includes("manager") == true;
  const RequestAccessor = [
    {
      KeyName: "fullName",
      ShowStatus: true,
      NmaeColumn: "الاسم",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "notesTable",
      ShowStatus: true,
      NmaeColumn: "اسم الجدول",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "notes",
      ShowStatus: true,
      NmaeColumn: " الملاحظة ",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "timeAndDate",
      ShowStatus: true,
      NmaeColumn: "وقت الاجراء",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
  ];
  const M_ApplicationsBtns = [
    {
      Click: async (e) => {
        //console.log(e.target.value, "sssssssssssss");

        setTechnicalReportNotesId(e.target.value);
        setPopUpBodyOPjectDataStatus(true);
      },
      content: "",
      className: shouldDisableFields
        ? "bi bi-pencil-square"
        : "bi bi-view-list",
      // className: "bi bi-pencil-square",

      id: "editBtn",
      title: "عرض",
      ShowStatus: true,
    },
    {
      Click: async (e) => {
        Swal.fire({
          title: state.jsonData.deleteTitlePopUp?.nameAR,
          icon: "error",
          // iconHtml: "؟",
          confirmButtonText: "تأكيد",
          cancelButtonText: "الغاء",
          showCancelButton: true,
          showCloseButton: true,
        }).then(async (res) => {
          if (res.isConfirmed == true) {
            const deleted = await dispatch(
              DeleteTechnicalReportNotes(e.target.value)
            );
            if (deleted.payload) {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "تم الحذف بنجاح",
                showConfirmButton: false,
                timer: 1500,
                // width: "500px",
              });
              //to refresh table
              dispatch(setRefreshTable());
            }
          }
        });
      },
      content: "",
      className: "bi bi-trash",
      id: "deleteBtn",
      title: "حذف",
      ShowStatus: shouldDisableFields ? true : false,
      // ShowStatus: true,
    },
  ];

  const getJson = async () => {
    var json = await loadConfig();
    // //console.log(json,"malwk");

    setJsonData(json);
  };
  useEffect(() => {
    setJsonData(getJson());
  }, []);

  const PopupOPjectData = {
    isPopupOpenStatus: true,
    isPopupOpenFunction: () => {},
    componentBody: <div>{<AddEditTechnicalReportNotes />}</div>,
    title: "الملاحظات",
    maxWidth: "500px",
    maxHeight: "500px",
  };

  const closePopUpBodyOPjectData = () => {
    setPopUpBodyOPjectDataStatus(false);
  };

  const popUpBodyOPjectData = {
    isPopupOpenStatus: popUpBodyOPjectDataStatus,
    isPopupOpenFunction: () => {
      setPopUpBodyOPjectDataStatus(false);
    },
    componentBody: (
      <div>
        <AddEditTechnicalReportNotes
          pR_TechnicalReportNotesId={TechnicalReportNotesId}
        />
      </div>
    ),
    title: "الملاحظات",
    maxWidth: "500px",
    maxHeight: "500px",
  };

  return (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"pR_TechnicalReportNotesId"}
        valueButtonAction={"pR_TechnicalReportNotesId"}
        URL={`api/PR_TechnicalReportNotes/GetPR_TechnicalReportNotesListData`}
        UrlBody={{
          pR_ReportsStagesGuid: props.pR_ReportsStagesGuid,
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={"الملاحظات"}
        selectRowNumber={true}
        checkBoksColumName="اظهار الملاحظة"
        sort={true}
        pagination={true}
        AppStatus={true}
        // tableBtn={!shouldDisableFields}
        tableBtn={shouldDisableFields ? true : false}
        sortTable={true}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        checkBoks={false}
        nameColumAction=""
        total={false}
        arrayButton={M_ApplicationsBtns}
        ArrayNameDataColum={[]}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        popUpBody={
          <PopupAHSF
            isPopupOpenStatus={popUpBodyOPjectData.isPopupOpenStatus}
            isPopupOpenFunction={popUpBodyOPjectData.isPopupOpenFunction}
            title={popUpBodyOPjectData.title}
            componentBody={popUpBodyOPjectData.componentBody}
            maxWidth={popUpBodyOPjectData.maxWidth}
            maxHeight={popUpBodyOPjectData.maxHeight}
          />
        }
      />
    </>
  );
};

export default TechnicalReportNotes;
